// extracted by mini-css-extract-plugin
export var brand = "_9e-9";
export var compact = "_9e-6";
export var extraSmall = "_9e-7";
export var icon = "_9e-0";
export var large = "_9e-4";
export var light = "_9e-1";
export var medium = "_9e-5";
export var outline = "_9e-b";
export var primaryDark = "_9e-a";
export var primaryLight = "_9e-8";
export var primaryModern = "_9e-c";
export var success = "_9e-2";
export var successSolid = "_9e-3";